import { IonIcon } from '@ionic/react'
import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { timeOutline } from 'ionicons/icons'
import type { DateTime } from 'luxon'
import { formatRouteRelativeTime } from '../../../helpers/datetime'

/** Leading labelled time on the hero card (v1's "Report At"). */
export const HeroTimeDetail = ({
  time,
  datetime,
  label = msg`Report At`,
}: {
  time: DateTime
  datetime: DateTime | undefined
  label?: MessageDescriptor
}) => {
  const { _ } = useLingui()
  return (
    <div className='assignment-detail__report-time'>
      <IonIcon icon={timeOutline} className='assignment-detail__report-icon' />
      <div>
        <div className='assignment-detail__report-label'>{_(label)}</div>
        <div className='assignment-detail__report-value'>
          {formatRouteRelativeTime(time, datetime)}
        </div>
      </div>
    </div>
  )
}
